import { useQuery } from "@tanstack/react-query";
import DealApi from "../api/DealApi";

export const useDealData = (dealId, enabled = false) => {
  const {
    data: dealData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["deal", dealId],
    queryFn: () =>
      DealApi.fetchDeal(dealId, {
        populate: "ofCompany,assignedTo",
        selectPopulate: "name",
      }),
    enabled,
    // staleTime: 24 * 60 * 60 * 1000, // Data remains fresh indefinitely
    staleTime: 30 * 1000, // Data remains fresh indefinitely
    // cacheTime: Infinity,
    cacheTime: 30 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
  // console.log("dealId", dealId, initialData, enabled);

  return { dealData, isLoading, dealId, isError, error };
};
